import { Hero } from '../components/Hero';
import { PodcastEmbed } from '../components/PodcastEmbed';
import './Podcast.css';

const videoEpisodes = [
  {
    id: '1',
    title: 'Episode 1: What is Consciousness?',
    description: 'An introduction to the fundamental questions about awareness and being.',
    youtubeId: 'dQw4w9WgXcQ', // Placeholder - replace with actual YouTube IDs
    date: 'January 15, 2024',
  },
  {
    id: '2',
    title: 'Episode 2: The Practice of Presence',
    description: 'Exploring practical techniques for cultivating present-moment awareness.',
    youtubeId: 'dQw4w9WgXcQ',
    date: 'January 8, 2024',
  },
  {
    id: '3',
    title: 'Episode 3: Beyond the Self',
    description: 'Investigating the nature of identity and what lies beyond our usual sense of self.',
    youtubeId: 'dQw4w9WgXcQ',
    date: 'January 1, 2024',
  },
];

const audioEpisodes = [
  {
    id: 'a1',
    title: 'Audio Episode 1: Morning Reflections',
    description: 'Short reflections to start your day with presence.',
    date: 'January 12, 2024',
  },
  {
    id: 'a2',
    title: 'Audio Episode 2: Evening Practice',
    description: 'Guided practice for winding down with awareness.',
    date: 'January 5, 2024',
  },
];

export function Podcast() {
  return (
    <div className="podcast-page">
      <Hero
        title="Podcast"
        subtitle="Deep conversations exploring consciousness, existence, and the practice of being"
        size="small"
      />

      <section className="podcast-page__section">
        <div className="container">
          <div className="podcast-page__header">
            <h2>
              <i className="fab fa-youtube"></i>
              Video Episodes
            </h2>
            <p>Watch in-depth discussions and visual explorations</p>
          </div>

          <div className="podcast-page__grid">
            {videoEpisodes.map(episode => (
              <PodcastEmbed
                key={episode.id}
                type="video"
                title={episode.title}
                description={episode.description}
                youtubeId={episode.youtubeId}
                date={episode.date}
              />
            ))}
          </div>
        </div>
      </section>

      <section className="podcast-page__section podcast-page__section--alt">
        <div className="container">
          <div className="podcast-page__header">
            <h2>
              <i className="fas fa-headphones"></i>
              Audio Episodes
            </h2>
            <p>Listen on the go—perfect for your commute or quiet moments</p>
          </div>

          <div className="podcast-page__grid">
            {audioEpisodes.map(episode => (
              <PodcastEmbed
                key={episode.id}
                type="audio"
                title={episode.title}
                description={episode.description}
                date={episode.date}
              />
            ))}
          </div>

          <div className="podcast-page__platforms">
            <h3>Coming Soon To</h3>
            <div className="podcast-page__platform-list">
              <span className="podcast-page__platform">
                <i className="fab fa-spotify"></i> Spotify
              </span>
              <span className="podcast-page__platform">
                <i className="fab fa-apple"></i> Apple Podcasts
              </span>
              <span className="podcast-page__platform">
                <i className="fab fa-google"></i> Google Podcasts
              </span>
            </div>
          </div>
        </div>
      </section>

      <section className="podcast-page__subscribe">
        <div className="container text-center">
          <h2>Never Miss an Episode</h2>
          <p>Subscribe to get notified when new episodes are released</p>
          <p className="podcast-page__coming-soon">
            <i className="fas fa-envelope"></i> Email subscription coming soon
          </p>
        </div>
      </section>
    </div>
  );
}
